import React from "react";
import PropTypes from "prop-types";
import Link from "components/elements/link";
import SVG from "components/elements/svg";
import TextContent from "components/elements/text-content";

const ThankYou = ({ form }) => (
  <section className="register-thank-you">
    <div className="container">
      <SVG src="check-in-circle-thin" className="register-thank-you__icon" />
      <h2 className="section-heading">Thank you for registering!</h2>
      <TextContent>
        <p>
          An email has been sent to{" "}
          <span className="text-medium">{form.email}</span>
          <br />
          Please check your email and click on the activation link that has been
          sent to you. If you don't see this, please check your spam / junk
          folder.
        </p>
        <Link to="/" className="btn btn-primary--outline with-arrow--reversed">
          <SVG src="arrow-left" className="arrow" />
          <span>Return to the home page</span>
        </Link>
      </TextContent>
    </div>
  </section>
);

ThankYou.propTypes = {
  form: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
};

ThankYou.defaultProps = {};

export default ThankYou;
